import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { WarningIcon } from 'images'

/**
 * @desc Connection state alert bar
 * @memberof components
 *
 * @param  {Boolean} isOnline                       [App is currently online]
 *
 * @type {PureComponent}
 */
export class ConnectionWarning extends React.PureComponent {
  static propTypes = {
    isOnline: PropTypes.bool
  }
  static defaultProps = {
    isOnline: false
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClickIntercept, true)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClickIntercept, true)
  }

  handleClickIntercept = (e) => {
    e.stopPropagation()
    e.preventDefault()

    return false
  }

  render() {
    const { isOnline } = this.props

    const blockClasses = classNames([
      'h-10',
      'fixed',
      'z-50',
      'top-0',
      'left-0',
      'right-0',
      'bottom-0',
      'flex',
      'items-center',
      'justify-center',
      'bg-black',
      'text-white',
      'text-center',
      'transition',
      { 'opacity-0': isOnline }
    ])

    return (
      <div className={blockClasses}>
        <WarningIcon />
        <p className="ml-4">Not Connected to Play MPE Services</p>
      </div>
    )
  }
}
